<template>
	<div class="">
		Location simple here
	</div>
	<!--	<form-field-wrap
			:field-props="fieldProps"
			:field-value="(Array.isArray(fieldProps.VALUE) && fieldProps.VALUE.includes(0)) ? fieldProps.VALUE[0] : fieldProps.VALUE"
			:input-focus="inputFocus"
			:is-error="isError"
			:is-switch="isSwitch"
			:with-label="fieldProps.hasOwnProperty('withLabel') ? fieldProps.withLabel : true"
		>
			<vue-select
				:options="fieldProps.ITEMS ? fieldProps.ITEMS : result.LOCATION"
				:value="valueSelect"
				:placeholder="fieldProps.PLACEHOLDER"
				:components="components"
				:input-id="fieldProps.ID ? fieldProps.ID : fieldProps.CODE"
				:loading="loading"
				v-validate="rules"
				:data-vv-as="fieldProps.TITLE"
				:name="fieldProps.CODE"
				@search:focus="labelSwitch('focus')"
				@search:blur="labelSwitch('blur')"
				@search="onSearch"
				@input="onSelectLocation">
				<template slot="no-options">{{ labelForSearch }}</template>
				<template slot="option" slot-scope="option">
						<span class="location_list_item">
							{{ option.label }}
						</span>
				</template>
				<template slot="selected-option" slot-scope="option">
					<span class="location_selected" v-html="valueSelect"></span>
				</template>
			</vue-select>
		</form-field-wrap>-->
</template>

<script>
export default {
	name: "Location",
	props: {
		fieldProps: {
			type: [Object, Array],
			default: () => {
			},
		},
		labelForSearch: {
			type: String,
			default: '',
		},
		selected: {
			type: String,
			default: '',
		},
		selectedCode: {
			type: [String, Number],
			default: '',
		},
		value: {
			type: String,
			default: '',
		},
		params: {
			type: [Array, Object],
			default: () => {
				return {}
			},
		},
		components: {
			type: [Object, Array],
			default: () => {
				return {}
			},
		},
		isSearch: {
			type: Boolean,
			default: true,
		},
		/** В VALUE в событиях будет записываться название, не код местоположения */
		useName: {
			type: Boolean,
			default: false,
		}
	},
	data() {
		return {
			result: {
				"ERRORS": {},
				"LOCATION": []
			},
			locationsPageN: 0,
			active: false,
			valueSelect: '',
			valueCode: this.selectedCode,
			searchPhrase: "",
			inputFocus: false,
			loading: false,
			error: false,

			ajaxValues: [],
		}
	},
	created() {
		this.init();
	},
	watch: {
		selected(newVal, oldVal) {
			this.setValueSelect(newVal);
			this.checkValid();
		},
		value(newVal, oldVal) {
			if (!newVal) {
				this.setValueSelect("");
				this.$emit("location-select", {location: {value: ""}, selected: this.valueSelect});
				return;
			}

			if (this.useName || this.valueCode == newVal)
				return;

			this.valueCode = newVal;

			this.search(() => {
			}, '', this.valueCode);
		},
		selectedCode() {
			this.init();
		}
	},
	computed: {
		loc() {
			return CitrusUi.getFilteredPhrases("CITRUS_LOCATION_");
		},
		isError() {
			this.error = this.errors.first(this.fieldProps.CODE);
			return this.error;
		},


		fieldValue() {
			return this.selected ? this.selected.label : "";
		},
		fieldValueMultiple() {
			return this.selected;
		},
		isMultiple() {
			return this.fieldProps.hasOwnProperty('MULTIPLE') && this.fieldProps.MULTIPLE;
		},
		isAjax() {
			return (this.fieldProps.hasOwnProperty('ITEMS_ACTION') && this.fieldProps.ITEMS_ACTION
				&& this.fieldProps.hasOwnProperty('ITEMS_COMPONENT_ACTION') && this.fieldProps.ITEMS_COMPONENT_ACTION);
		},
		rules() {
			let arRules = [];

			if (this.fieldProps.REQUIRED == "Y") {
				arRules.push('required');
			}
			if (this.fieldProps.RULES) {
				arRules = arRules.concat(this.fieldProps.RULES);
			}

			let stRules = arRules.join('|');
			return stRules;
		},
	},
	methods: {
		init() {
			if (!this.params.hasOwnProperty('FILTER_SITE_ID') || this.params.FILTER_SITE_ID.length <= 0) {
				this.params.FILTER_SITE_ID = BX.message('SITE_ID');
			}

			if (!this.params.hasOwnProperty('LOCATIONS_PAGE_SIZE') || this.params.LOCATIONS_PAGE_SIZE <= 0) {
				this.params.LOCATIONS_PAGE_SIZE = 200;
			}

			if (!this.params.hasOwnProperty('AJAX_URL') || this.params.AJAX_URL.length <= 0) {
				this.params.AJAX_URL = '/bitrix/components/bitrix/sale.location.selector.search/get.php';
			}

			if (this.selected) {
				this.setValueSelect(this.selected);
			} else if (this.selectedCode) {
				let code;
				if (String(this.selectedCode).length < 10) {
					code = (Array(10).join('0') + this.selectedCode).slice(-10);
				} else code = this.selectedCode;

				this.loading = true;
				let data = this.prepareAjaxData(false, false, code);
				this.ajaxRequest(data, false, code);
			}
		},
		prepareAjaxData(isCountry, phrase, code) {
			let data = {
				select: {
					0: 'CODE',
					1: 'TYPE_ID',
					2: 'IS_PARENT',
					VALUE: 'ID',
					DISPLAY: 'NAME.NAME'
				},
				version: 2,
				additionals: {
					0: 'PATH'
				},
				filter: {
					"=NAME.LANGUAGE_ID": BX.message('LANGUAGE_ID'),
					"=SITE_ID": this.params.FILTER_SITE_ID
				}
			};

			if (code)
				data.filter['=CODE'] = code;

			if (isCountry)
				data.filter['=PARENT_ID'] = 0;

			if (phrase)
				data.filter['=PHRASE'] = phrase;

			if (!isCountry) {
				data["PAGE_SIZE"] = this.params.LOCATIONS_PAGE_SIZE;
				data["PAGE"] = this.locationsPageN;
			}

			return data;
		},
		parseResponseData(value) {
			let result = [];

			if (!value["result"] || !value["data"] || !value["data"]["ITEMS"])
				return result;

			for (let item of value["data"]["ITEMS"]) {

				let display_path = "",
					pathParts = [],
					firstParent = false
				;

				if (typeof item["PATH"] != 'undefined' && value["data"].ETC && value["data"].ETC.PATH_ITEMS) {
					for (let pathItem of item.PATH) {
						let pItemId = pathItem;
						if (typeof value["data"].ETC.PATH_ITEMS[pItemId] != 'undefined') {
							let pItem = value["data"].ETC.PATH_ITEMS[pItemId];
							pathParts.push(pItem["DISPLAY"]);
							if (!firstParent) {
								firstParent = {
									value: pItem["CODE"],
									display_path_first: pItem["DISPLAY"],
									display_path: "",
									id: pItem["VALUE"],
								};
							}
						}
					}
				}

				display_path = pathParts.join(", ");
				let label = item["DISPLAY"];
				if (display_path.length > 0) {
					label += ' (' + display_path + ')';
				}

				result.push(
					{
						value: item["CODE"],
						label: label,
						display_path_first: item["DISPLAY"],
						display_path: display_path,
						id: item["VALUE"],
						parent: firstParent,
					}
				);
			}

			return result;
		},
		ajaxRequest(data, loading, code = '', callbackSuccess, callbackError) {
			/**
			 * TODO заменить на новый BX.ajax.runComponentAction
			 * для этого нужно создать action в компоненте (определить в каком, так как в стандартном bitrix:sale.location.selector.search не реализована поддержка BX.ajax.runComponentAction)
			 */
			BX.ajax({
				url: this.params.AJAX_URL,
				method: 'post',
				dataType: 'json',
				async: true,
				processData: true,
				start: true,
				data: data,
				onsuccess: (result) => {
					if (callbackSuccess) {
						callbackSuccess(result, code, loading);
					} else {
						this.onAjaxSuccess(result, code, loading);
					}
				},
				onfailure: (type, e) => {
					if (callbackError) {
						callbackError(loading);
					} else {
						this.onAjaxError(loading);
					}
				}
			});
		},
		onAjaxSuccess(result, code, loading) {
			let res = this.parseResponseData(result);

			this.result.LOCATION = res;
			if (loading) {
				loading(false);
			}
			this.loading = false;

			if (code && res && res[0]) {
				let location = res[0];
				this.setValueSelect(location)
				this.onSelectLocation(location);
			} else if (this.useName) {
				this.setValueSelect(this.searchPhrase);

				this.$emit("location-select", {location: {value: ""}, selected: this.searchPhrase});
				this.$emit("input", this.searchPhrase);
			}

			setTimeout(this.checkValid, 0);
		},
		onAjaxError(loading) {
			if (loading) {
				loading(false);
			}
			this.loading = false;
		},
		onSearch(search, loading) {
			if (search.length > 2 && this.isSearch) {
				loading(true);
				this.searchPhrase = search;
				this.search(loading, search);
			}
		},
		search(loading, phrase, code) {
			let data = this.prepareAjaxData(false, phrase, code);
			this.ajaxRequest(data, loading, code);
		},
		onSelectLocation(location) {
			if (!location) {
				this.setValueSelect("");
				this.$emit("location-select", {location: {value: ""}, selected: this.valueSelect});
				this.$emit("input", "");

				return;
			}

			this.setSelectedLocation(location);
		},
		labelSwitch(active) {
			if (active == 'focus') {
				this.inputFocus = true;
			} else {
				this.inputFocus = false;
			}
		},
		setSelectedLocation(location) {
			if (this.fieldProps.TYPE == 'list') {
				let splits = location.label.split(',');
				splits[0] = '<b>' + splits[0] + '</b>';

				this.setValueSelect(splits.join());
			} else {
				this.setValueSelect(location);
			}

			this.$emit('location-select', {
				location: location,
				selected: this.valueSelect
			});
			this.$emit('input', this.useName ? this.valueSelect : location.value);
			this.checkValid();
		},
		setValueSelect(location) {
			if (typeof location == "string") {
				this.valueSelect = location;
				return;
			}

			let label = location.display_path_first;
			if (location.display_path) {
				label += ', ' + location.display_path;
			}

			this.valueSelect = label;
		},

		async checkValid() {
			let isValid = true;

			if (this.$refs['formItemPreset']) {
				this.$refs['formItemPreset'].validate('', (errorMessage) => {
					if (errorMessage && errorMessage.length > 0) {
						isValid = false;
					}
				});
			}

			if (this.$refs['formItem']) {
				this.$refs['formItem'].validate('', (errorMessage) => {
					if (errorMessage && errorMessage.length > 0) {
						isValid = false;
					}
				});
			}

			return isValid;
		},
		resetValid: async function () {
			if (this.$refs['formItem']) {
				this.$refs['formItem'].clearValidate();
			}

			if (this.$refs['formItemPreset']) {
				this.$refs['formItemPreset'].clearValidate();
			}
		},
	}
}
</script>
